import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFlag1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconFlag1"><Path d="M4.75 14.75V3.75C4.75 3.19772 5.19772 2.75 5.75 2.75H19.3815C20.1802 2.75 20.6566 3.64015 20.2135 4.3047L17.6198 8.1953C17.3959 8.5312 17.3959 8.9688 17.6198 9.3047L20.2135 13.1953C20.6566 13.8599 20.1802 14.75 19.3815 14.75H4.75ZM4.75 14.75V21.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconFlag1;
